import React from 'react'
import { connect } from 'react-redux'

import { updateUserInfo } from 'actions'
import {
  currentUserIdSelector,
  profilePictureSelector,
  fullNameSelector,
  employerSelector,
  titlesSelector,
  updateUserInfoPendingSelector,
} from 'selectors'

import {
  Form,
  Field,
  Label,
  Input,
  RolesInput,
  ProfilePictureInput,
} from 'components/form'
import Button from 'components/Button'

class EditUserInfo extends React.Component {
  state = {
    name: this.props.name,
    employer: this.props.employer,
    titles: this.props.titles,
    profilePicture: {
      preview: this.props.profilePicture,
    },
  }

  componentDidUpdate(prevProps) {
    if (!this.props.loading && prevProps.loading) {
      this.props.closeModal()
    }
  }

  submit = e => {
    e.preventDefault()
    this.props.updateUserInfo(this.props.userId, {
      name: this.state.name,
      employer: this.state.employer,
      titles: this.state.titles,
      profilePicture:
        this.state.profilePictureHasChanged && this.state.profilePicture,
    })
  }

  render() {
    return (
      <Form onSubmit={this.submit}>
        <Field>
          <Label htmlFor="profilePicture">Profilbilde</Label>
          <ProfilePictureInput
            id="profilePicture"
            value={this.state.profilePicture}
            onChange={profilePicture =>
              this.setState({
                profilePicture,
                profilePictureHasChanged: true,
              })
            }
          />
        </Field>
        <Field>
          <Label htmlFor="name">Navn</Label>
          <Input
            id="name"
            value={this.state.name}
            onChange={e => this.setState({ name: e.target.value })}
          />
        </Field>
        {/*<Field>
          <Label htmlFor="employer">Arbeidsgiver</Label>
          <Input
            id="employer"
            value={this.state.employer}
            onChange={e => this.setState({ employer: e.target.value })}
          />
        </Field>*/}
        <Field>
          <Label htmlFor="titles">Titler</Label>
          <RolesInput
            id="titles"
            value={this.state.titles}
            onChange={titles => this.setState({ titles })}
          />
        </Field>
        <Button type="submit">Lagre</Button>
      </Form>
    )
  }
}

const mapStateToProps = state => ({
  loading: updateUserInfoPendingSelector(state),
  userId: currentUserIdSelector(state),
  profilePicture: profilePictureSelector(state),
  name: fullNameSelector(state),
  employer: employerSelector(state),
  titles: titlesSelector(state) || [],
})

const mapDispatchToProps = { updateUserInfo }

export default connect(mapStateToProps, mapDispatchToProps)(EditUserInfo)



// WEBPACK FOOTER //
// ./src/pages/Profile/EditProfile.js